/**
 * Class strings shared across the dashboards.
 *
 * Its own module for the same reason as `format.ts`: `shared.tsx` exports
 * components, and a module that mixes components with anything else opts out of
 * React fast refresh.
 *
 * `FIELD` is here because it had already been copied into three files. That is
 * how the buttons drifted four pixels under the touch minimum — nine copies of
 * one class string, each edited once. The `min-h-11` below is §4's 44 px, and
 * the ring is §13's: a focus style you can actually see, not the browser
 * default someone turned off.
 */

export const FIELD = 'w-full min-h-11 rounded-lg border border-neutral-700 '
  + 'bg-neutral-900 px-3 py-2.5 text-sm text-white placeholder:text-neutral-500 '
  + 'transition focus:border-purple-500 focus:outline-none focus:ring-2 '
  + 'focus:ring-purple-500/50'

/** A small bordered control that sits beside text — Resend, Revoke, Copy. */
export const SMALL_BUTTON = 'inline-flex min-h-11 shrink-0 items-center gap-1.5 '
  + 'rounded-lg border border-neutral-700 px-2.5 text-[11px] font-medium '
  + 'text-neutral-300 transition disabled:opacity-40'
